import { render, staticRenderFns } from "./XmDrawer.vue?vue&type=template&id=97d92622&scoped=true&"
import script from "./XmDrawer.vue?vue&type=script&lang=js&"
export * from "./XmDrawer.vue?vue&type=script&lang=js&"
import style0 from "./XmDrawer.vue?vue&type=style&index=0&id=97d92622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d92622",
  null
  
)

export default component.exports